import StaffManager from '../features/people/StaffManager';

export default function StaffPage() {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Personel Hesapları</h1>
          <p>Personel hesaplarını yönetin, yetkileri düzenleyin ve ekibi kolayca sisteme alın.</p>
        </div>
      </header>
      <section className="page-section">
        <StaffManager />
      </section>
    </div>
  );
}
